var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"file-upload-list-wrapper"},[_c('create-form',_vm._b({ref:"form",attrs:{"data":_vm.localData,"field-list":_vm.localFieldList}},'create-form',_vm.$props,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }